import { IProcedure } from 'common/schema/Procedure';
import { yup } from 'common/validation/initYup';
import { ICaptchaCryptedTokens } from 'server/captcha/CaptchaService';

/**
 * DTO per la bozza di una richiesta (istanza)
 */
export const createDraftRequestValidator = () => {
  return yup
    .object({
      id: yup.number().notRequired(),
      values: yup.mixed().required(),
      /** Specifica se la richiesta deve essere inviata al momento del salvataggio */
      sendRightNow: yup.boolean().default(false),
      // bindToken: yup.string()
      captchaTokens: yup
        .object<ICaptchaCryptedTokens>()
        .notRequired()
        .default({})
    })
    .noUnknown()
    .required();
};

export type ICreateDraftRequestDto = yup.InferType<
  ReturnType<typeof createDraftRequestValidator>
>;
